<template>
  <div>
    <DialogGeoNotif />
    <CGU />
    <v-btn elevation="8" icon style="background: white; position: absolute; left: 10px; top: 10px; z-index: 99" @click="goBack()" v-if="isRouterHistoryExists()"
      ><v-icon>mdi-chevron-left</v-icon></v-btn
    >
    <v-btn elevation="8" icon style="background: white; position: absolute; right: 5px; top: 335px; z-index: 99" @click="openDialogGeoNotif()" v-if="status !== true">
      <v-icon>mdi-crosshairs-gps</v-icon>
    </v-btn>

    <span class="px-2" style="cursor: pointer; position: absolute; right: 0px; top: 380px; z-index: 99; font-size: 0.6em" @click="openCGU()">
      {{ $t('cgu.openmodal') }}
    </span>

    <v-container style="background: rgba(0, 0, 0, 0.6); height: 400px; width: 100%; position: absolute; z-index: 80; text-align: center" fill-height fluid v-if="showLoading">
      <v-row align="center" justify="center">
        <v-col>
          <v-progress-circular :size="40" color="white" indeterminate></v-progress-circular>
        </v-col>
      </v-row>
    </v-container>
    <MglMap
      container="map-test"
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      style="height: 400px"
      @load="onMapLoaded"
      :interactive="interactive"
      maxPitch="0"
      minPitch="0"
      logoPosition="bottom-left"
      :dragRotate="rotate"
      :maxZoom.sync="maxZoom"
      :minZoom.sync="minZoom"
    >
      <MglGeojsonLayer :sourceId="parkingsSourceId" :source="geoJsonSourceParkings" :layerId="parkingsLayerId" :layer="geoJsonLayerParkings" @click="parkingSelected" />
      <MglGeojsonLayer :sourceId="destinationsSourceId" :source="geoJsonSourceDestinations" :layerId="destinationsLayerId" :layer="geoJsonLayerDestinations" @click="destinationSelected" />
      <MglGeojsonLayer v-for="(item, index) in sourcesCanvas" v-bind:key="index" :sourceId="sourceCanvasIdPrefix + index" :source="item" :layerId="layerCanvasIdPrefix + index" :layer="layerCanvas" />
    </MglMap>
    <canvas v-for="(item, index) in sourcesCanvas" v-bind:key="index" :id="`canvas${index}`" style="display: none"></canvas>

    <div v-if="current_parking === undefined && current_site !== undefined && !showLoading" class="px-auto">
      <div v-if="attendance && attendance.length > 0">
        <v-card-text style="text-transform: uppercase; letter-spacing: -0.01rem; color: gray; font-weight: 500; font-size: 0.75rem; text-align: center">
          {{ $t('sitedetails.attendance_site') }}
        </v-card-text>

        <AttendanceBarChart :chart-data="chartCollection" :options="chartOptions" style="height: 140px" />
      </div>
      <SiteInformations :item="current_site" name="short_name" style="padding-bottom: 90px"></SiteInformations>
      <div style="position: fixed; bottom: 0px; width: 100%" class="mx-auto px-3">
        <v-btn class="my-4" block :color="config.COLORS.ORANGE" style="color: white; font-size: 0.7rem" elevation="2" x-large @click="selectBestParking">{{ $t('sitedetails.gotodestination') }}</v-btn>
      </div>
    </div>

    <div v-if="current_parking !== undefined && !showLoading" transition="slide-y-reverse-transition" class="px-auto" style="color: rgb(97, 97, 97)">
      <div style="position: relative" v-show="hasCurrentParkingPicture()">
        <div style="margin: auto; width: 100%; position: absolute; top: -50px; z-index: 999">
          <div class="mt-2 mb-1 justify-center" style="margin: auto">
            <v-img max-width="50px" :src="`${config.FRONT.PATH}/${current_parking.local_picture}`" style="margin: auto"> </v-img>
          </div>
        </div>
      </div>
      <div style="position: relative" v-show="!hasCurrentParkingPicture()">
        <div style="margin: auto; width: 100%; position: absolute; top: -50px; z-index: 999">
          <div
            class="mt-2 mb-1 justify-center rounded-circle"
            :style="`width: 50px; height: 50px; color: white; font-weight: 600; font-size: 1.3em; background: ${current_parking.fill_color}; padding: 9px; margin: auto`"
          >
            <div style="font-size: 25px; text-align: center; margin: 0; padding: 0; line-height: 1em">{{ current_parking.name }}</div>
            <div style="font-size: 9px; text-align: center; margin: 0; padding: 0; line-height: 0.5rem">
              {{ current_parking.subname !== undefined ? current_parking.subname : $t('sitedetails.area') }}
            </div>
          </div>
        </div>
      </div>

      <div style="padding-bottom: 90px">
        <div class="mt-4 px-4 pt-3" style="font-weight: 600">
          <v-icon class="my-3" small :color="current_parking.score_color"> mdi-circle</v-icon> {{ $tc('sitedetails.available_spots', current_parking.spots) }}
        </div>

        <div class="mx-auto px-4" style="max-width: 100%; width: 100%">
          <v-slide-group multiple show-arrows ref="slideGroup">
            <v-slide-item v-for="(item, index) in current_parking.static_tags" v-bind:key="index">
              <v-chip class="my-2 mr-1" :color="current_parking.score_color" label style="color: white; font-weight: 400">
                {{ $t(`static_tags.${item}`) }}
              </v-chip>
            </v-slide-item>
          </v-slide-group>
        </div>

        <v-divider class="my-1"></v-divider>

        <v-row no-gutters v-if="current_parking.driving_duration !== null && current_parking.walking_duration !== null && current_parking.walking_calories !== null" class="px-4">
          <v-col>
            <v-icon class="my-3">mdi-car</v-icon> {{ formatDuration(current_parking.driving_duration) }}
            <v-tooltip bottom v-if="!location">
              <template v-slot:activator="{ on }">
                <v-icon small class="my-3" v-on="on">mdi-information</v-icon>
              </template>
              <template v-slot:default>{{ $t('sitedetails.driving_time_infos') }}</template>
            </v-tooltip>
          </v-col>
          <v-col style="text-align: center"> <v-icon class="my-3"> mdi-walk</v-icon> {{ Math.ceil(current_parking.walking_duration / 60) }} {{ $t('min') }} </v-col>
          <v-col style="text-align: right"> <v-icon class="my-3"> mdi-fire</v-icon> {{ parseInt(current_parking.walking_calories / 1000) }} {{ $t('kcal') }}</v-col>
        </v-row>

        <div style="position: fixed; bottom: 0px; width: 100%" class="mx-auto px-3">
          <v-btn class="my-4" block :color="config.COLORS.ORANGE" style="color: white" elevation="2" x-large :to="{ name: 'scene.navigation' }">{{ $t('sitedetails.gowaitingpage') }}</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex';
import { MglMap, MglGeojsonLayer } from 'vue-mapbox';

import AttendanceBarChart from '@/components/AttendanceBarChart';
import DialogGeoNotif from '@/components/DialogGeoNotif';
import CGU from '@/components/CGU';
import SiteInformations from '@/components/SiteInformations';
import { Config } from '@/config';

export default {
  name: 'App',
  components: {
    MglMap,
    MglGeojsonLayer,
    AttendanceBarChart,
    DialogGeoNotif,
    CGU,
    SiteInformations,
  },
  data() {
    return {
      showLoading: true,
      config: Config,

      // MAPBOX config
      center: null,
      zoom: null,
      minZoom: Config.MAPBOX.MIN_ZOOM,
      maxZoom: Config.MAPBOX.MAX_ZOOM,
      rotate: false,
      accessToken: Config.MAPBOX.TOKEN,
      mapStyle: 'mapbox://styles/tibeoh/ckgtx9fjj0xes19nokhtk60rf',
      interactive: true,

      //MAPBOX destinations
      destinationsSourceId: 'destinationsSourceId',
      geoJsonSourceDestinations: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      destinationsLayerId: 'destinationsLayerId',
      geoJsonLayerDestinations: {
        id: 'destinationsLayerId',
        type: 'fill',
        paint: {
          'fill-color': {
            type: 'identity',
            property: 'fillcolor',
          },
          'fill-opacity': 0.2,
        },
      },

      //MAPBOX parkings
      parkingsSourceId: 'parkingsSourceId',
      geoJsonSourceParkings: {
        type: 'geojson',
        data: {
          type: 'FeatureCollection',
          features: [],
        },
      },
      parkingsLayerId: 'parkingsLayerId',
      geoJsonLayerParkings: {
        id: 'parkingsLayerId',
        type: 'fill',
        paint: {
          'fill-color': {
            type: 'identity',
            property: 'fillcolor',
          },
          'fill-outline-color': 'rgba(255,255,255, 1)',
          'fill-opacity': ['case', ['boolean', ['feature-state', 'click'], false], 1, 0.5],
        },
      },

      //MAPBOX Canvas
      sourceCanvasIdPrefix: 'sourcecanvas',
      sourcesCanvas: [],
      layerCanvasIdPrefix: 'layercanvas',
      layerCanvas: { type: 'raster' },

      //Attendance chart
      chartCollection: {},
      chartDataDefault: {
        labels: [],
        datasets: [],
      },

      chartOptions: {
        scales: {
          xAxes: [
            {
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
                display: false,
              },
            },
          ],
          yAxes: [
            {
              gridLines: {
                color: 'rgba(0, 0, 0, 0)',
              },
              ticks: {
                beginAtZero: true,
                display: false,
                steps: 20,
                stepValue: 5,
                max: 100,
              },
            },
          ],
        },
        legend: {
          display: false,
        },
        tooltips: {
          enabled: false,
        },
        responsive: true,
        maintainAspectRatio: false,
      },
    };
  },
  computed: {
    ...mapState('sites', ['current_site', 'parkings', 'destinations', 'attendance', 'attendance_labels', 'current_parking']),
    ...mapState('auth', ['settings']),
    ...mapState('history', ['history']),
    ...mapState('geoNotifPermissions', ['status', 'location', 'address']),
    ...mapState('CGU', ['getCGUStatus']),
    ...mapGetters('CGU', ['getCGUStatus']),
  },
  watch: {
    current_site: function (newCurrentSite) {
      // Update map if current site is a new one selected
      if (newCurrentSite !== undefined) {
        this.center = [this.current_site.location.lng, this.current_site.location.lat];
        this.zoom = this.current_site.zoom;
        this.$store.map.jumpTo({ zoom: this.zoom, center: this.center });
      }
    },
    destinations: function (destinations) {
      //Update destinations on the map
      destinations.map(destination => {
        if (destination.fill_color !== undefined) {
          destination.geoJson.properties.fillcolor = destination.fill_color;
        }
        this.geoJsonSourceDestinations.data.features.push(destination.geoJson);
      });
      this.$store.map.getSource(this.destinationsSourceId).setData(this.geoJsonSourceDestinations.data);
    },
    parkings: function (parkings) {
      //Update parkings on the map
      parkings.map((parking, index) => {
        if (parking.fill_color !== undefined) {
          parking.geoJson.properties.fillcolor = parking.fill_color;
        }
        if (this.sourcesCanvas[index] !== undefined) {
          this.sourcesCanvas[index] = parking.canvas;
        } else {
          this.sourcesCanvas.push(parking.canvas);
        }
        if (parking.spots !== undefined && parking.attendance_percentage !== undefined) {
          this.refreshCanvas(index, parking.name, parking.attendance_percentage);
        }
        if (this.geoJsonSourceParkings.data.features[index] !== undefined) {
          this.geoJsonSourceParkings.data.features[index] = parking.geoJson;
        } else {
          this.geoJsonSourceParkings.data.features.push(parking.geoJson);
        }

        if (this.current_parking !== undefined && this.current_parking._id === parking._id) {
          this.setCurrentParking(parking);
        }
      });
      this.$store.map.getSource(this.parkingsSourceId).setData(this.geoJsonSourceParkings.data);
    },

    current_parking: function () {
      // Fix horizontal scroll
      if (this.$refs.slideGroup && this.$refs.slideGroup._data) {
        this.$refs.slideGroup._data.scrollOffset = 0;
      }
    },

    attendance: function (attendance) {
      let chartDataset = {
        backgroundColor: [],
        data: [],
        categoryPercentage: 1,
        barPercentage: 0.9,
      };
      attendance.forEach(attendance => {
        const currentAttendanceValue = attendance !== null ? attendance : 0;
        if (currentAttendanceValue >= Config.ATTENDANCE.RED.VALUE) {
          chartDataset.data.push(currentAttendanceValue);
          chartDataset.backgroundColor.push(Config.ATTENDANCE.RED.COLOR);
        } else if (currentAttendanceValue >= Config.ATTENDANCE.ORANGE.VALUE && currentAttendanceValue < Config.ATTENDANCE.RED.VALUE) {
          chartDataset.data.push(currentAttendanceValue);
          chartDataset.backgroundColor.push(Config.ATTENDANCE.ORANGE.COLOR);
        } else {
          chartDataset.data.push(currentAttendanceValue);
          chartDataset.backgroundColor.push(Config.ATTENDANCE.GREEN.COLOR);
        }
      });

      this.chartDataDefault.datasets.push(chartDataset);
      this.chartDataDefault.labels = this.attendance_labels;
      this.chartCollection = this.chartDataDefault;
    },

    async location(newLocation) {
      this.showLoading = true;
      await this.getNavigationParkings(newLocation);
      this.showLoading = false;
    },
  },
  async created() {
    if (this.$route.params === undefined || this.$route.params.id === undefined || this.$route.params.id === '') {
      this.$router.push({ name: 'scene.sites.list' }).catch(() => {});
    }
  },
  async mounted() {
    this.getSettings();
    this.resetCurrentParking();
    if (this.$route.query.parking !== undefined) {
      this.$router.replace({ name: 'scene.site.details' }).catch(() => {});
    }
  },
  methods: {
    ...mapActions('sites', {
      getById: 'getById',
      getParkings: 'getParkings',
      getDestinations: 'getDestinations',
      getNavigationParkings: 'getNavigationParkings',
      setCurrentParking: 'setCurrentParking',
      resetCurrentParking: 'resetCurrentParking',
      resetState: 'resetState',
    }),
    ...mapActions('auth', { getSettings: 'getSettings' }),
    ...mapActions('geoNotifPermissions', {
      setStatus: 'setStatus',
    }),
    ...mapActions('CGU', {
      openCGUModal: 'open',
    }),
    async onMapLoaded(event) {
      this.$store.map = event.map;
      await this.getById(this.$route.params.id);
      await this.getDestinations(this.$route.params.id);
      await this.getParkings(this.$route.params.id);
      await this.getNavigationParkings(this.location);
      this.showLoading = false;

      let nbPictures = 0;
      if (this.current_site.local_logo) {
        this.addImageOnMap(event.map, this.current_site.local_logo, nbPictures);
        nbPictures += 1;
      }

      if (this.current_site.assets_pictures_map !== undefined) {
        this.current_site.assets_pictures_map.forEach(asset => {
          this.addImageOnMap(event.map, asset, nbPictures);
          nbPictures += 1;
        });
      }
    },
    isRouterHistoryExists() {
      return this.history.length > 1 && this.history[0] === 'scene.sites.list' ? true : false;
    },
    goBack() {
      if (this.$route.query.parking !== undefined) {
        this.resetCurrentParking();
        this.$store.map.getSource(this.parkingsSourceId)._data.features.forEach(feature => {
          this.$store.map.setFeatureState({ source: this.parkingsSourceId, id: feature.id }, { click: false });
        });
        this.$router.replace({ name: 'scene.site.details' }).catch(() => {});
      } else {
        this.$router.go(-1);
      }
    },
    hasCurrentParkingPicture() {
      return this.current_parking !== undefined && this.current_parking.local_picture !== undefined;
    },
    parkingSelected(event) {
      event.component.getSourceFeatures().forEach(feature => {
        let value = false;
        if (feature.id === event.mapboxEvent.features[0].id) {
          value = !event.mapboxEvent.features[0].state.click;
          if (value === false) {
            this.resetCurrentParking();
            this.$router.replace({ name: 'scene.site.details' }).catch(() => {});
          } else {
            this.setCurrentParking(this.parkings[event.mapboxEvent.features[0].id]);
            this.$router.replace({ name: 'scene.site.details', query: { parking: this.current_parking._id } }).catch(() => {});
          }
        }
        event.map.setFeatureState({ source: this.parkingsSourceId, id: feature.id }, { click: value });
      });
    },

    destinationSelected(event) {
      this.resetCurrentParking();
      event.map.getSource(this.parkingsSourceId)._data.features.forEach(feature => {
        event.map.setFeatureState({ source: this.parkingsSourceId, id: feature.id }, { click: false });
      });
      if (this.$route.query.parking !== undefined) {
        this.$router.replace({ name: 'scene.site.details' }).catch(() => {});
      }
    },

    selectBestParking() {
      let minAttendance = 100;
      let bestParkingIndex = undefined;
      this.parkings.forEach((parking, index) => {
        if (parking.attendance_percentage <= minAttendance) {
          minAttendance = parking.attendance_percentage;
          bestParkingIndex = index;
        }
      });
      this.setCurrentParking(this.parkings[bestParkingIndex]);
      this.$router.replace({ name: 'scene.site.details', query: { parking: this.current_parking._id } }).catch(() => {});
      this.$store.map.setFeatureState({ source: this.parkingsSourceId, id: this.$store.map.getSource(this.parkingsSourceId)._data.features[bestParkingIndex].id }, { click: true });
    },

    refreshCanvas(index, name, attendance = 0) {
      let c = document.getElementById(`canvas${index}`);
      let ctx = c.getContext('2d');
      let b = 25,
        w = 1000 + b * 2,
        paddingTop = 700,
        // centerX = w / 2,
        // radius = 350,
        // sizeLetter = 320,
        // borderCircle = 30,
        // margin = 50,
        heightRectangle = 150,
        h = 1000 + b * 2;
      // paddingTop = h / 2 - (2 * radius + borderCircle * 2 + margin + heightRectangle) / 2;

      c.width = w;
      c.height = h;

      // //Draw circle
      // ctx.beginPath();
      // ctx.arc(centerX, paddingTop + radius + borderCircle / 2, radius, 0, 2 * Math.PI, false);
      // ctx.fillStyle = 'white';
      // ctx.fill();
      // // Draw border of circle
      // ctx.lineWidth = borderCircle;
      // ctx.strokeStyle = 'black';
      // ctx.stroke();

      // // Type text center in the circle
      // ctx.fillStyle = 'black';
      // ctx.font = sizeLetter + 'px Helvetica';
      // ctx.textAlign = 'center';
      // ctx.textBaseline = 'middle';
      // ctx.fillText(name, centerX, paddingTop + radius + borderCircle);

      // draw border of progress bar
      ctx.fillStyle = '#eff0f0';
      // ctx.fillRect(0, 2 * radius + borderCircle * 2 + margin + paddingTop, w, heightRectangle);
      ctx.fillRect(0, paddingTop, w, heightRectangle);

      // fill inside progress bar
      ctx.fillStyle = 'white';
      // ctx.fillRect(b, b + 2 * radius + borderCircle * 2 + margin + paddingTop, w - 2 * b, heightRectangle - 2 * b);
      ctx.fillRect(b, paddingTop + b, w - 2 * b, heightRectangle - 2 * b);

      //fill inside progress bar with color of attendance
      if (attendance < Config.ATTENDANCE_BAR.YELLOW.VALUE) {
        ctx.fillStyle = Config.ATTENDANCE_BAR.GREEN.COLOR;
      } else if (attendance >= Config.ATTENDANCE_BAR.YELLOW.VALUE && attendance < Config.ATTENDANCE_BAR.ORANGE.VALUE) {
        ctx.fillStyle = Config.ATTENDANCE_BAR.YELLOW.COLOR;
      } else if (attendance >= Config.ATTENDANCE_BAR.ORANGE.VALUE && attendance < Config.ATTENDANCE_BAR.RED.VALUE) {
        ctx.fillStyle = Config.ATTENDANCE_BAR.ORANGE.COLOR;
      } else {
        ctx.fillStyle = Config.ATTENDANCE_BAR.RED.COLOR;
      }
      // ctx.fillRect(b, b + 2 * radius + borderCircle * 2 + margin + paddingTop, attendance * 10, heightRectangle - 2 * b);
      ctx.fillRect(b, paddingTop + b, attendance * 10, heightRectangle - 2 * b);
    },

    addImageOnMap(map, img, index) {
      if (img && img.lat_top_left_corner && img.lng_top_left_corner && img.name && img.delta_lat && img.delta_lng) {
        map.addSource(`myImageSource${index}`, {
          type: 'image',
          url: `${Config.FRONT.PATH}/${img.name}`,
          coordinates: [
            [img.lng_top_left_corner, img.lat_top_left_corner + img.delta_lat],
            [img.lng_top_left_corner + img.delta_lng, img.lat_top_left_corner + img.delta_lat],
            [img.lng_top_left_corner + img.delta_lng, img.lat_top_left_corner],
            [img.lng_top_left_corner, img.lat_top_left_corner],
          ],
        });
        map.addLayer({
          id: `overlay${index}`,
          source: `myImageSource${index}`,
          type: 'raster',
          paint: {
            'raster-opacity': 1,
          },
        });
      }
    },

    async openDialogGeoNotif() {
      if (this.status === false) {
        this.setStatus(undefined);
      }
    },

    openCGU() {
      if (this.getCGUStatus === false) {
        this.openCGUModal();
      }
    },

    formatDuration(duration) {
      let durationInMinutes = duration / 60;

      if (durationInMinutes < 60) {
        return `${Math.ceil(durationInMinutes)} ${this.$t('min')}`;
      } else {
        let hours = Math.round(durationInMinutes / 60);
        let minutes = Math.max(0, Math.ceil(durationInMinutes - 60 * hours));
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        return `${hours}${this.$t('hours')}${minutes}${this.$t('min')}`;
      }
    },
  },
};
</script>

<style>
.v-slide-group__prev,
.v-slide-group__next {
  display: none !important;
}

.mapboxgl-control-container,
.mapboxgl-ctrl-bottom-right {
  display: none;
}
</style>
